import CreateResourceInteractor from "../../core/interactor/app/crud/CreateResourceInteractor";
import { IDocumentType } from "../../documentTypes/model/DocumentType";
import DocumentTypeMapper from "../../documentTypes/service/DocumentTypeMapper";
import DocumentTypeParamMapper from "../../documentTypes/service/DocumentTypeParamMapper";
import Constants from "../common/Constants";
export default class CreateLegalViewTypeInteractor {
  private createResource: CreateResourceInteractor<IDocumentType>;

  constructor({ createResource }: any) {
    this.createResource = createResource;
  }

  async execute(model: IDocumentType) {
    return this.createResource.execute(
      Constants.legalViewTypesPath,
      DocumentTypeMapper,
      DocumentTypeParamMapper,
      model
    );
  }
}
